const namespace = "UPCOMINGCLASSES_";

const CONSTANTS = {
  UPCOMINGCLASSES_LIST_GET: `${namespace}LIST_GET`,
  UPCOMINGCLASSES_NEW_SERVICE: `${namespace}NEW_SERVICE`,
  UPCOMINGCLASSES_LIST_LOADING: `${namespace}LIST_LOADING`,
  UPCOMINGCLASSES_LIST_SUCCESS: `${namespace}LIST_SUCCESS`,
  UPCOMINGCLASSES_APIRES_SUCCESS: `${namespace}APIRES_SUCCESS`,
  UPCOMINGCLASSES_LIST_ERROR: `${namespace}LIST_ERROR`,
};

export default CONSTANTS;
